import React, { useState, useEffect } from "react";
import { Grid, Card, Modal, Header } from "semantic-ui-react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {jwtDecode} from "jwt-decode";
import { useNavigate } from "react-router-dom";
import {
  deleteDatasets,
  DelRequestSuccess,
} from "../../actions/dataConsoleAction";
import Loader from "../../components/Loader";
import {
  fetchOrganisations
} from "../../actions/adminConsoleAction";


const token = localStorage.getItem("token");
let userName = "";

if (token) {
  const decodedToken = jwtDecode(token);
  userName = decodedToken.name;  // Assuming the token has a "name" field
}
const OrganizationLandingPage = ({
  columns,
  data,
  showToaster,
  setDeleteStatus,
  loaderFlag,
  handleEditOrganization,
  handleDisableOrganization,
  handleEnableOrganization,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);
  const { loadings, responseDelete, responseDeleteStatus } = useSelector(
    (state) => state.getdeleteDataSetReducer || {}
  );
  const { response } = useSelector(
    (state) => state.getlistDatasetReducer || {}
  );
  const [openEnableBox, setOpenEnableBox] = useState(false);
  const [openDeleteBox, setOpenDeleteBox] = useState(false);
  const [desktopDeleteFlag, setDesktopDeleteFlag] = useState(false);
  const [deleteOrganizationName, setDeleteOrganizationName] = useState("");
  const [deleteOrganizationId, setDeleteOrganizationId] = useState("");
  const [disableOrgRowdata, setdisableOrgRowdata] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Polling interval (in milliseconds)
  const pollingInterval = 5000; // Poll every 5 seconds

  useEffect(() => {
    if (
      responseDeleteStatus &&
      responseDeleteStatus === 200 &&
      desktopDeleteFlag
    ) {
      showToaster(`${deleteOrganizationName} deleted successfully`, "success");
      setDeleteStatus(true);
      setDesktopDeleteFlag(false);
      dispatch(DelRequestSuccess([]));
    }
  }, [desktopDeleteFlag, responseDelete, responseDeleteStatus, dispatch]);


  useEffect(() => {
    // Function to fetch organizations
    const fetchData = async () => {
      try {
        await dispatch(fetchOrganizations()); // Assuming you have an action to fetch organizations
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    // Initial fetch
    fetchData();

    // Set up polling
    const intervalId = setInterval(fetchData, pollingInterval);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const handleEdit = (name, id) => {
    navigate(`/organization/${id}/${name}`);
  };

  const handleDelete = async (organizationName, organizationID) => {
    setDeleteOrganizationName(organizationName);
    setDeleteOrganizationId(organizationID);
    setOpenDeleteBox(true);
  };

  const handleDisableOrganizationConfirm = async (row)  =>{
    setdisableOrgRowdata(row)
    setDeleteOrganizationName(row.orgName);
    setOpenDeleteBox(true);
  }

  const handleEnableOrganizationConfirm = async (row)  =>{
    setdisableOrgRowdata(row)
    setDeleteOrganizationName(row.orgName);
    setOpenEnableBox(true);
  }

  const actionDeleteOrganization = async () => {
    setDesktopDeleteFlag(true);
    setOpenDeleteBox(false);
    setOpenEnableBox(false);
    try {
      handleDisableOrganization(disableOrgRowdata);
    } catch (error) {
      console.error("Error in delete Organization:", error);
    }
  };

  const actionEnableOrganization = async () => {
    setDesktopDeleteFlag(true);
    setOpenDeleteBox(false);
    setOpenEnableBox(false);
    try {
      handleEnableOrganization(disableOrgRowdata);
    } catch (error) {
      console.error("Error in delete Organization:", error);
    }
  };

  const handleClose = async () => {
    setOpenDeleteBox(false);
    setOpenEnableBox(false);
  };

  const totalItems = data.length;

  const getTimeAgo = (joiningDate) => {
    const today = moment().startOf("day");
    const joinedDate = moment.utc(joiningDate).local().startOf("day");

    const timeDifference = today.diff(joinedDate, "days");

    if (timeDifference === 0) {
      return "Created today";
    } else if (timeDifference === 1) {
      return "Created yesterday";
    } else {
      return `Created ${timeDifference} days ago`;
    }
  };

  return (
    <>
      {loaderFlag && <Loader />}
      <Grid columns={3} stackable className="organizations-table">
        {data.length > 0
          ? data.map((row) => (
              <Grid.Column key={row.id} data-cy="organization-list-cy">
                <Card fluid className="qac-card"> {/* This class is used for targeting */}
                  <Card.Content>
                    <div className="card-header">
                      <div className="card-icon" style={{ backgroundColor: row.color || '#f0eee9' }}>
                        {row.logoBase64 ? (
                          <img src={row.logoBase64} alt="Logo" className="icon-initials" />
                        ) : (
                          <span className="icon-initials">{row.initials}</span>
                        )}
                      </div>
                      <div className="card-title">
                        <Card.Header className="data-console-header">
                          {row.orgName}
                        </Card.Header>
                      </div>
                    </div>
                    <Card.Meta className="card-description">
                      {row.orgDescription}
                    </Card.Meta>
                    <div className="card-body">
                      <div className="card-contact">
                        <div className="card-contact-name">{row.orgAdminName}</div>
                        <div className="card-contact-email">
                          {row.orgAdminCommunicationEmail}
                        </div>
                      </div>
                    </div>
                  </Card.Content>
                  <Card.Content extra className="card-footer">
                    <div className="card-footer-text">
                      <span>{getTimeAgo(row.createdUTC)}</span>
                      <span>&nbsp; • &nbsp; {userName}</span>
                    </div>
                    {!row.disabled ? ( 
                    <><div className="card-footer-actions-enable-disable">
                    <div className="">
                      <img
                        className=""
                        src="/images/enable.svg"
                        alt="Edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDisableOrganizationConfirm(row);
                        } }
                        style={{ cursor: "pointer" }}
                        data-cy="organization-detail-link" />
                    </div>
                  </div><div className="card-footer-actions">
                      <div className="tableButtonContainer">
                        <img
                          className="tableButton"
                          src="/images/Edit.svg"
                          alt="Edit"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditOrganization(row);
                          } }
                          style={{ cursor: "pointer" }}
                          data-cy="organization-detail-link" />
                      </div>
                    </div></>

                     ) : (
<div className="card-footer-actions-enable-disable">
                    <div className="">
                      <img
                        className=""
                        src="/images/disable.svg"
                        alt="Edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEnableOrganizationConfirm(row);
                        } }
                        style={{ cursor: "pointer" }}
                        data-cy="organization-detail-link" />
                    </div>
                  </div>

                     )}
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))
          : ""}
      </Grid>

      <Modal
        open={openEnableBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Enable Organization</Header>

          <p>Are you sure you want to Enable "{deleteOrganizationName}"</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="ui button cancel-btn"
            onClick={handleClose}
            data-cy="cancel-organization-delete"
          >
            Cancel
          </button>
          <button
            className="ui primary button add-btn"
            onClick={actionEnableOrganization}
            data-cy="delete-organization-confirm"
          >
            Enable
          </button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openDeleteBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Disable Organization</Header>

          <p>Are you sure you want to Disable "{deleteOrganizationName}"</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-organization-delete"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={actionDeleteOrganization}
            data-cy="delete-organization-confirm"
          >
            Disable
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default OrganizationLandingPage;
